export const processHtml = (input) => {
  if(input === '<p></p>') { return null; }

  return input;
}

export default processHtml;